import { IncludeType } from '../../../common';
import { Image } from '../../models';
import { productCatalogueHttp } from '../product-catalogue-api';

export const getGroupImages = async (
  groupId: number,
  locale: string,
  includeType: IncludeType = IncludeType.Available
): Promise<Image[]> => {
  const url = `/group/${groupId}/images?include=${includeType}&marketLocale=${locale}`;
  const response = await productCatalogueHttp.get<Image[]>(url);
  return response.data;
};
